// UseCases.tsx
export function UseCases() {
  return (
    <section className="py-32 px-6 bg-neutral-50" data-lenis-scroll>
      <div className="max-w-5xl mx-auto text-center space-y-12">
        <h2 className="text-3xl font-semibold tracking-tight">
          Perfect For
        </h2>

        <div className="flex flex-wrap justify-center gap-6 text-sm">
          <span className="px-6 py-3 border rounded-full">Cafés</span>
          <span className="px-6 py-3 border rounded-full">Restaurants</span>
          <span className="px-6 py-3 border rounded-full">Food Courts</span>
          <span className="px-6 py-3 border rounded-full">Hotels</span>
        </div>
      </div>
    </section>
  );
}
